import { Body, BodyWithClass } from "@client/ui";
import React from "react";
import { COMPANY } from "utils/constants";

const AboutUs = () => {
  return (
    <div>
      <BodyWithClass
        text={COMPANY.AboutUs.title}
        className="font-primary font-bold text-[30px] mb-[30px]"
      />
      <BodyWithClass
        text={COMPANY.AboutUs.description}
        className="font-primary text-[16px] mb-[20px]"
      />
    </div>
  );
};

export default AboutUs;
